import { useMemo } from 'react';
import { PosSelect, PosSelectProps } from 'src/core/POS/PosSelect';
import { useOffices } from 'src/hooks/api/useOffices';
import { ContentId } from 'src/utils/constants/contentId';

export type OfficeSelectorProps = Omit<
  PosSelectProps,
  'valueOptionsContent'
> & {
  currentOfficeId?: number | null;
};

export const OfficeSelector = ({
  currentOfficeId,
  placeholderText = ContentId.SelectOffice,
  ...rest
}: OfficeSelectorProps) => {
  const { query: officesQuery } = useOffices();
  const offices = officesQuery.data ?? [];

  const valueOptionsContent = useMemo(
    () =>
      Object.fromEntries(
        offices
          .filter((o) => o.officeId !== currentOfficeId)
          .map((o) => [String(o.officeId), o.officeName])
      ),
    [offices, currentOfficeId]
  );

  return (
    <PosSelect
      style={{ width: '100%' }}
      {...rest}
      placeholderText={placeholderText}
      valueOptionsContent={valueOptionsContent}
      loading={officesQuery.isLoading}
      sortMode="ascending"
      sortBy="value"
    />
  );
};
